import NotificationConfigurationDialog from './notificationConfigurationDialog.container';

export default NotificationConfigurationDialog;
